/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { ILegendItem } from '@hcecbp/legend-component';
import { TFunction } from '@scuf/localization/dist/types';
import descriptors from '../../../../locales/en-US/descriptors';

const d = descriptors.energyManagement;

export const getLegendItems = (
  t: TFunction,
  showSavingsData: boolean = true,
  showActualData: boolean = true,
  showBaselineData: boolean = true,
  showComfortData: boolean = false,
  showStatusChart: boolean = true,
  showExcludedDays: boolean = false
): ILegendItem[] => {
  const legendItems = [];
  if (showSavingsData) {
    legendItems.push({
      text: t(d.SAVINGS),
      color: '',
      className: 'savings'
    });
  }
  if (showActualData) {
    legendItems.push({
      text: t(d.ACTUAL),
      color: '',
      className: 'actual'
    });
  }
  if (showBaselineData) {
    legendItems.push({
      text: t(d.CALCULATED),
      color: '',
      className: 'baseline'
    });
  }
  if (showStatusChart) {
    legendItems.push({
      text: t(d.inactiveDays),
      color: '',
      className: 'inactive'
    });
  }
  if (showExcludedDays) {
    legendItems.push({
      text: t(d.excludedDays),
      color: '',
      className: 'excluded'
    });
  }
  if (showComfortData) {
    legendItems.push({
      text: t(d.siteComfort),
      color: '',
      className: 'comfort'
    });
  }
  return legendItems;
};
